import React from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { PlainButton, Tooltip } from "@culturehq/components";

import { t } from "app/utils";

import LayerUpIcon from "components/common/icons/LayerUpIcon";
import rearrangeTracks from "../../utils/creatomate/rearrangeTracks";

interface MoveLayerUpButtonProps {
  activeElement?: ElementState;
  preview?: Preview;
}

const MoveLayerUpButton: React.FC<MoveLayerUpButtonProps> = ({ activeElement, preview }) => {
  const enabled = preview && activeElement;

  const handleUpElement = () => {
    if (preview && activeElement) rearrangeTracks(activeElement.track, "up", preview);
  };

  return (
    <Tooltip tip={t("Move layer up")}>
      <PlainButton
        className="Up-Btn"
        onClick={handleUpElement}
        disabled={!enabled}
      >
        <LayerUpIcon />
      </PlainButton>
    </Tooltip>
  );
};

export default MoveLayerUpButton;
